import React from 'react';

import { EchartDoubleBar } from './EchartDoubleBar';

const xAxisData = [
  'Other',
  'Patient diagnoses',
  'Patient demographics',
  'Medications',
  'Lab values over time',
  'Progress notes',
  'Medical history',
  'Vital signs',
  'Immunization dates',
  'Allergies',
  'Past surgical history',
  'EKG or ECG',
  'Stress test',
  'Patient insurance information',
  'Medical imaging',
];
const seriesDataOne = [18, 91, 65, 91, 79, 40, 79, 70, 62, 81, 67, 56, 53, 51, 53];
const seriesDataTwo = [3, 64, 37, 67, 57, 48, 65, 48, 27, 65, 50, 20, 12, 20, 31];

export const ProviderScheme = () => {
  const echartOptions = {
    tooltip: {
      show: false,
    },
  };

  return (
    <EchartDoubleBar
      dataBar={xAxisData}
      firstName="MD - Doctor of Medicine"
      secondName="DMD - Doctor of Dental Medicine"
      seriesDataOne={seriesDataOne}
      seriesDataTwo={seriesDataTwo}
      echartOptions={echartOptions}
    />
  );
};
